<app-megamenu></app-megamenu>

<div class="page-content">
  <div class="container">
    <h1>Privacy Policy</h1>
    <p class="last-updated">Last updated: March 24, 2026</p>
    
    <div class="policy-content">
      <section class="policy-section">
        <h2>Our Commitment to Your Privacy</h2>
        <p>
          At {{ config.name }}, we understand that your privacy is important to you, and it's important to us too. 
          This Privacy Policy explains how we collect, use, and protect your personal information when you visit 
          our website or use our pest control services.
        </p>
      </section>

      <section class="policy-section">
        <h2>Information We Collect</h2>
        <h3>Personal Information You Provide</h3>
        <p>When you contact us for services or request a quote, we may collect:</p>
        <ul>
          <li>Your name and contact information (phone number, email address)</li>
          <li>Your address and ZIP code for service scheduling</li>
          <li>Details about your pest control needs</li>
          <li>Payment information for billing purposes</li>
        </ul>

        <h3>Information We Collect Automatically</h3>
        <p>When you visit our website, we may automatically collect:</p>
        <ul>
          <li>Your IP address and browser information</li>
          <li>Pages you visit and time spent on our site</li>
          <li>Device information and operating system</li>
          <li>Cookies and similar tracking technologies</li>
        </ul>
      </section>

      <section class="policy-section">
        <h2>How We Use Your Information</h2>
        <p>We use your personal information to:</p>
        <ul>
          <li>Provide pest control services and schedule appointments</li>
          <li>Communicate with you about your service needs</li>
          <li>Process payments and maintain billing records</li>
          <li>Improve our services and customer experience</li>
          <li>Send you important updates about your service</li>
          <li>Comply with legal requirements and protect our business</li>
        </ul>
      </section>

      <section class="policy-section">
        <h2>Our Privacy Approach</h2>
        <p>
          We believe in protecting your privacy from the ground up. Here's how we approach data protection 
          in a way that puts you first:
        </p>
        
        <div class="privacy-principles">
          <div class="principle">
            <h4>We're Proactive About Protection</h4>
            <p>
              Rather than waiting for problems to happen, we actively look for ways to keep your information 
              safe and address potential risks before they become issues.
            </p>
          </div>

          <div class="principle">
            <h4>Privacy is Our Default Setting</h4>
            <p>
              We design our systems with the highest level of data protection built right in. You shouldn't 
              have to worry about adjusting settings to keep your information private.
            </p>
          </div>

          <div class="principle">
            <h4>Privacy by Design</h4>
            <p>
              From the moment we start planning any new process or system, we think about how to protect 
              your privacy. It's not an afterthought—it's built into everything we do.
            </p>
          </div>

          <div class="principle">
            <h4>Easy to Use, Still Secure</h4>
            <p>
              We believe you shouldn't have to choose between convenience and privacy. Our systems are 
              designed to be user-friendly while maintaining the highest security standards.
            </p>
          </div>

          <div class="principle">
            <h4>Protected Every Step of the Way</h4>
            <p>
              Your personal information is kept safe throughout its entire lifecycle with us—from the 
              moment you share it until we securely delete it when it's no longer needed.
            </p>
          </div>

          <div class="principle">
            <h4>Transparency You Can Trust</h4>
            <p>
              We want you to understand exactly how we handle your personal information. That's why we're 
              open about our practices and always available to answer your questions.
            </p>
          </div>

          <div class="principle">
            <h4>Building Your Trust</h4>
            <p>
              Your trust is earned, not given. We work hard every day to show you that we take your privacy 
              seriously and handle your personal information with the care and respect it deserves.
            </p>
          </div>
        </div>
      </section>

      <section class="policy-section">
        <h2>Information Sharing</h2>
        <p>We do not sell, rent, or trade your personal information. We may share your information only in these limited circumstances:</p>
        <ul>
          <li>With service providers who help us operate our business (like payment processors)</li>
          <li>When required by law or to protect our legal rights</li>
          <li>In connection with a business transfer or merger</li>
          <li>With your explicit consent</li>
        </ul>
      </section>

      <section class="policy-section">
        <h2>Data Security</h2>
        <p>
          We implement appropriate technical and organizational measures to protect your personal information 
          against unauthorized access, alteration, disclosure, or destruction. This includes:
        </p>
        <ul>
          <li>Secure data transmission using encryption</li>
          <li>Regular security assessments and updates</li>
          <li>Limited access to personal information on a need-to-know basis</li>
          <li>Employee training on data protection practices</li>
        </ul>
      </section>

      <section class="policy-section">
        <h2>Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access the personal information we have about you</li>
          <li>Request corrections to inaccurate information</li>
          <li>Request deletion of your personal information</li>
          <li>Opt out of marketing communications</li>
          <li>File a complaint about our privacy practices</li>
        </ul>
      </section>

      <section class="policy-section">
        <h2>Cookies and Tracking</h2>
        <p>
          Our website uses cookies to improve your browsing experience and help us understand how visitors 
          use our site. You can control cookie settings through your browser preferences.
        </p>
      </section>

      <section class="policy-section">
        <h2>Children's Privacy</h2>
        <p>
          Our services are not directed to children under 13, and we do not knowingly collect personal 
          information from children under 13. If we become aware that we have collected such information, 
          we will take steps to delete it promptly.
        </p>
      </section>

      <section class="policy-section">
        <h2>Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. When we do, we will post the updated policy 
          on this page and update the "Last updated" date. We encourage you to review this policy periodically.
        </p>
      </section>

      <section class="policy-section">
        <h2>Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy or our privacy practices, please contact us:
        </p>
        <div class="contact-info">
          <p><strong>{{ config.name }}</strong></p>
          <p>Phone: {{ config.phone.display }}</p>
          <p>Email: {{ config.email }}</p>
          <p>Address: {{ config.address.full }}</p>
        </div>
      </section>
    </div>
  </div>
</div>

<app-footer></app-footer>